<ng-container *ngIf="!hotelSummeryFetched && csrStatus; else HotelTemplate">
  <div class="container lg:px-0 flex items-start gap-6">
    <div class="mobile-full-width relative">
      <iho-pdp-skeleton [isMobile]="navigatorVal" />
    </div>
  </div>
</ng-container>

<!-- [class.overflow-y-hidden]="!hotelSummeryFetched"
  [class.h-0]="!hotelSummeryFetched"
  [class.opacity-0]="!hotelSummeryFetched" -->
<div class="container lg:px-0 flex items-start gap-6 relative">
  <div class="w-full xl:max-w-[72%]">
    <iho-pdp-sticky-tabs *ngIf="(searchBoxService.mobileSearchBoxIsOpen | async) !== true && hotelSummeryFetched"
      (fragmentTabPending)="disableFragment()" [scrolledSection]="scrolledSection()"
      (selectTab)="goToSelectedTab($event)" class="sticky top-0 z-20 block" accommodation="hotel" />

    <section id="baseData" #baseData>
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-pdp-hotel-base-data [dataSource]="hotelInfoSummary?.HotelHeader"
        [isFavorite]="dataRooms!.isFavourite" (goToMapEmit)="goToMap()" />
      </ng-container>
    </section>

    <iho-plus-section [hotelName]="hotelInfoSummary.Name" [dataSource]="hotelInfoSummary?.ClubOffers ?? []"
      (scrollToRooms)="goToRooms()" />

    <!-- <iho-count-down /> -->

    <section id="facilities" class="md:border-top" #facilities>
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-hotel-facilities [dataSource]="hotelInfoSummary?.Facilities"
          [HotelInternetParking]="hotelInfoSummary?.HotelInternetParking"
          [travelHealth]="hotelInfoSummary?.TravelHealth" />
      </ng-container>
    </section>
    <div class="w-full hidden lg:block" *ngIf="hotelInfoSummary?.CityHotels?.Url == '/kish-hotels/'">
      <a [href]="'https://shop.iranhotelonline.com/?utm_source=&utm_medium=shop&utm_campaign=bannerpdp&utm_content=pdpkish'" target="_blank" rel="nofollow">
        <img src="assets/images/shop-desk.svg" class="w-full">
      </a>
    </div>
    <div class="w-full block lg:hidden" *ngIf="hotelInfoSummary?.CityHotels?.Url == '/kish-hotels/'">
      <a [href]="'https://shop.iranhotelonline.com/?utm_source=&utm_medium=shop&utm_campaign=bannerpdp&utm_content=pdpkish'" target="_blank" rel="nofollow">
        <img src="assets/images/shop.svg" class="w-full">
      </a>
    </div>
    <section id="banner-reserve" *ngIf="hotelSummeryFetched && csrStatus() && hotelInfoSummary?.CityHotels?.Url != '/kish-hotels/'"
      class="w-full float-start flex justify-start items-center rounded-lg my-2 bg-[#EFF8FF] text-[#026AA2] border-[#84CAFF] border-solid border">
      <img src="assets/images/banner-logo.png" class="float-right">
      <swiper [config]="configbanner" class="lg:h-[30px] h-[45px] w-full">
        <ng-template swiperSlide class="cursor-default">
          <span class="font-bold mr-2 lg:text-base text-sm">رایگان رزرو کن، در چهار قسط پرداخت کن!</span>
        </ng-template>
        <ng-template swiperSlide class="cursor-default">
          <span class="font-bold mr-2 lg:text-base text-sm">رایگان رزرو کن، در چهار قسط پرداخت کن!</span>
        </ng-template>
      </swiper>
    </section>
    <ng-container *ngIf="upperSimilarSection() && csrStatus()">
      <ng-template [ngTemplateOutlet]="similarHotelsTemplate"></ng-template>
    </ng-container>

    <section id="rooms" #rooms>
      <div *ngIf="hotelSummeryFetched">
        <ng-container *ngIf="!pdpUiService.roomsLoading(); else roomsSkeleton">

          <div *ngIf="comboRooms && !hideCombos"
            class="bg-metal-50 rounded-lg mobile-full-width md:py-8 py-4 mt-4 px-4 flex flex-col relative z-[4] md:-mb-12 -mb-8">
            <h2 class="text-lg block text-black font-bold ">اتاق های ترکیبی</h2>
            <p class="text-sm text-black-300 mt-1 mb-4">
              با انتخاب اتاق های ترکیبی همواره میتوانید هتل مورد نظر خود را در تاریخ مورد نظر خودتان در 2 یا چند اتاق
              متفاوت رزرو کنید.
            </p>

            <!-- Combo-Rooms mobile template -->
            <div class="!block md:!hidden w-full bg-white rounded p-4" id="combo-rooms">
              <swiper [config]="config" class="border-bottom">
                <!--  -->
                <ng-template swiperSlide *ngFor="let _ of comboRooms?.rooms?.roomInfos; let i = index">
                  <iho-pdp-rooms-cards (addComboRooms)="addComboRoomsToCart($event)"
                    (removeComboRooms)="removeComboFromCart($event)"
                    [roomId]="i === 0 ? comboRooms?.rooms?.id! : comboRooms?.rooms?.secondId!"
                    [comboRoomName]="i === 0 ? undefined : comboRooms?.rooms?.secondName"
                    [secondComboRoomImage]="i === 0 ? undefined : comboRooms?.rooms?.secondImage"
                    [dataSource]="comboRooms?.rooms!" [isCombo]="true" [isMobile]="true" />
                </ng-template>
              </swiper>


              <div class="flex flex-col float-left gap-2 pt-2 mt-2 mb-2">
                <div class="flex w-full items-center gap-1 justify-end">
                  <span class="text-sm text-muted">{{pdpUiService.comboRooms()?.[0]?.totalPrice?.nights}} شب</span>
                  <span class="text-black-500 text-2xl font-bold">{{
                    pdpUiService.comboRooms()?.[0]?.totalPrice?.ihoPrice | toToman | number : '2.'
                    }}</span>
                  <span class="text-sm text-muted">تومان</span>
                </div>

                <button mat-flat-button color="primary" class="w-full !h-11 !text-base font-semi-bold"
                  (click)="!pdpUiService.selectedComboRooms()?.length ? addComboRoomsToCart(comboRooms?.comboId) : removeComboFromCart(comboRooms?.comboId)"
                  [disabled]="disableComboBtn">
                  انتخاب اتاق های ترکیبی
                </button>
              </div>

            </div>

            <!-- Combo-Rooms desktop template -->
            <iho-pdp-rooms-cards class="!hidden md:!block" [roomId]="comboRooms?.rooms?.id!"
              [dataSource]="comboRooms?.rooms!" (addComboRooms)="addComboRoomsToCart($event)"
              (removeComboRooms)="removeComboFromCart($event)" [isCombo]="true"
              [secondComboRoomImage]="comboRooms?.rooms?.secondImage" [comboRoomName]="comboRooms?.rooms?.secondName" />
          </div>

          <iho-pdp-rooms-wrapper class="shadow-sm" [cityId]="cityId" [dataSource]="dataRooms!"
            (goToRoomSectionInPdp)="goToRooms()" (goToSimilarHotelsSection)="goToSimilarHotelsSection()" />
        </ng-container>
      </div>

    </section>

    <section id="rules" class="mt-4" #rules>
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-hotel-rules [dataSource]="hotelInfoSummary" />
      </ng-container>
    </section>

    <section id="map" class="mt-4" #map>
      <ng-container *ngIf="hotelSummeryFetched && csrStatus()">
        <iho-pdp-map [dataSource]="hotelInfoSummary?.HotelHeader" />
      </ng-container>
    </section>

    <section id="distance" class="mt-4" #distance>
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-distance [dataSource]="hotelInfoSummary?.DistanceInfo" [nearBies]="hotelInfoSummary?.NearBies" />
      </ng-container>
    </section>

    <section id="about" class="mt-4" #about>
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-about-hotel [dataSource]="hotelInfoSummary" />
      </ng-container>
    </section>


    <section id="comments" class="mt-4" #comments>
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-comments [hotelId]="hotelInfoSummary?.HotelId" [dataVotes]="hotelInfoSummary?.Votes"
          [HotelHeader]="hotelInfoSummary?.HotelHeader"
          [dataSourceLabelHotelReview]="hotelInfoSummary?.LabelHotelReview" />
      </ng-container>
    </section>

    <ng-container *ngIf="lowerSimilarSection() && csrStatus()">
      <ng-template [ngTemplateOutlet]="similarHotelsTemplate"></ng-template>
    </ng-container>

    <ng-template #similarHotelsTemplate>
      <section class="p-4 bg-metal-50 rounded-md flex flex-col items-stretch gap-4 mobile-full-width mt-4"
        id="similarHotelsSection" *ngIf="(similarHotels$ | async) as similarHotels" #similarHotelsSection>
        <h2 class="text-xl font-bold">با هتل های مشابه مقایسه کنید</h2>

        <div class="!block md:!hidden w-full">
          <swiper [config]="config" id="swiperSimilarHotel">
            <ng-template swiperSlide *ngFor="let cardData of similarHotels?.Hotels">
              <iho-similar-hotels-card [dataSource]="cardData" [hotelId]="hotelInfoSummary?.HotelId" [type]="2" />
            </ng-template>
          </swiper>
        </div>
        <div class="hidden md:grid md:grid-cols-4 items-center gap-4">
          <iho-similar-hotels-card *ngFor="let item of similarHotels?.Hotels" [type]="2" [dataSource]="item" />
        </div>
      </section>
    </ng-template>


    <section id="about" class="my-4" #faq>
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-faq [dataSource]="hotelInfoSummary" />
      </ng-container>
    </section>

    <section id="links" class="my-4" #faq>
      <ng-container *ngIf="hotelSummeryFetched">
        <iho-relatedlinks [pdpLinks]="hotelInfoSummary?.NearStreets" />
      </ng-container>
    </section>

    <ng-container *ngIf="hotelSummeryFetched">
      <iho-pdp-breadcrumb class="md:hidden flex" [dataSource]="hotelInfoSummary?.BreadCrumb"
        [hotelName]="hotelInfoSummary?.Name" />
    </ng-container>

  </div>

  <!-- [class.sticky]="this.pdpUiService.selectedRooms().length < 4 -->
  <div class="w-[24rem] top-[10px] hidden lg:block z-40 sticky">
    <ng-container *ngIf="hotelSummeryFetched">
      <iho-pdp-sticky-sidebar (goToRooms)="goToRooms()" />
    </ng-container>
  </div>

</div>


<ng-template #HotelTemplate>
  <section class="flex flex-col relative" *ngIf="hotelSummeryFetched">
    <div class="container lg:px-0 md:mb-4">

      <div class="w-full justify-between my-4 hidden md:flex">
        <!--
              [queryParams]="{search_box: hotelInfoSummary.HotelHeader.Address.CityName ,refer: 'hotelinfo', type: '1', 'city': cityId }"
              -->
        <iho-pdp-breadcrumb [hotelName]="hotelInfoSummary.Name" class="flex" [dataSource]="hotelInfoSummary.BreadCrumb"
          [cityName]=" hotelInfoSummary.HotelHeader.Address.CityName" />
        <a mat-button color="primary" [href]="hotelInfoSummary.BreadCrumb[1].Url"
          (click)="navToPlp(hotelInfoSummary.BreadCrumb[1].Url,$event)"
          class="text-blue-500 !font-bold flex items-center">
          همه {{ hotelInfoSummary.HotelHeader.TypeName }} های {{ hotelInfoSummary.HotelHeader.Address.CityName }}
        </a>
      </div>

      <div class="mobile-full-width relative">
        <div (click)="backToPlp()"
          class="bg-white rounded-full z-30 lg:hidden p-3 h-[32px] w-[32px] flex justify-center items-center absolute top-[10px] right-[22px]">
          <i class="ico-ArrowRight text-xl"></i>
        </div>

        <div (click)="addToFavorite()"
          class="bg-white rounded-full z-30 lg:hidden h-[32px] w-[32px] flex justify-center items-center absolute top-[10px] left-[22px]">
          <div class="typing-animation scale-[0.65]" *ngIf="loadingFavorite; else toggleFavorite">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <ng-template #toggleFavorite>
            <div ngClass="relative z-30"
            *ngIf="dataRooms!.isFavourite && this.authService.getUserData()();else noFavorite"
              class="filled-heart" style="width:22px"></div>
            <ng-template #noFavorite>
              <i class="ico-Heart text-xl relative z-30"></i>
            </ng-template>
          </ng-template>
        </div>
        <iho-pdp-gallery-wrapper [dataSource]="hotelInfoSummary?.ModalHotelGallery"
         [ecolodgeType]="1"
          [hotelId]="hotelInfoSummary?.HotelId" />
      </div>
    </div>
  </section>
</ng-template>


<div class="lg:hidden fixed bottom-[64px] w-full bottom-affix-box-shadow !z-[5]">
  <iho-pdp-mobile-affix />
    <div *ngIf="showInitRoom &&  lowestSelectedRoomsPrice != 0"
      class="w-full bg-[#F4F3FF] text-[#6938EF] p-3 rounded-lg flex justify-start items-center gap-2">
      <i class="ico-DiscountChat text-xl text-[#6938EF]"></i>
      <span class="font-bold text-xs">امکان پرداخت در 4 قسط {{lowestSelectedRoomsPrice / 4 | toToman | number:
        '2.'}}
        تومانی! </span>
    </div>
  <div class="w-full bg-white flex justify-between items-center !z-[55]" id="init-section-room"
    *ngIf="showInitRoom &&  lowestSelectedRoomsPrice != 0">
    <div class="pr-4">
      <p class="text-base text-gray-500 font-bold">شروع قیمت از</p>
      <p>
        <span class="text-black-500 text-2xl font-bold">
          {{ lowestSelectedRoomsPrice | toToman | number: '2.'
          }}
        </span>
        <span class="text-sm text-muted">تومان</span>
      </p>
    </div>
    <button (click)="scrollToRoom()" mat-flat-button color="primary" class="!h-11 w-[140px]">
      انتخاب اتاق
    </button>
  </div>
</div>

<iho-bottom-nav-mobile [userData]="userData()" />


<ng-template #roomsSkeleton>
  <div class="bg-metal-50 rounded-lg w-full py-8 mt-4 px-4 flex flex-col">
    <h5 class="pb-2 border-bottom text-lg block text-black font-bold">انتخاب
      اتاق</h5>
    <iho-pdp-rooms-skeleton />
  </div>
</ng-template>

<safarmarket-pixel />